'use client'

import { useQuery } from '@tanstack/react-query'

import {
  getPublicGeminiChatbot,
  createPublicGeminiChatSession,
} from '@/lib/api/generated/public-gemini-chatbot/public-gemini-chatbot'
import QueryKey from '@/lib/query-key'

export { createPublicGeminiChatSession }

export const usePublicGeminiChatbotQuery = (agentId: string) => {
  return useQuery({
    queryKey: [QueryKey.PUBLIC_GEMINI_CHATBOT, agentId],
    queryFn: ({ signal }) => getPublicGeminiChatbot(agentId, { signal }),
    enabled: !!agentId,
  })
}
